/* ============================================================================
   ag-ux-browse.js — Armour Guards · browse lane (2026-08-21)
   ----------------------------------------------------------------------------
   Screen-size quick filter for collection pages.

   WHY THIS EXISTS
   Live store ships only Availability + Price storefront facets (admin-owned;
   theme cannot add facets), yet every card's title carries its screen size.
   This script narrows the rendered grid by size — the way customers actually
   choose between guards for the same car.

   CONTRACT
   - Progressive enhancement: without JS, or with <2 distinct sizes, the rail
     stays hidden and nothing on the page changes.
   - Idempotent + re-entrant: Shopify facet filtering REPLACES the whole
     section node (2.0-filters.js) and load-more APPENDS cards; a debounced
     MutationObserver re-initializes/reapplies after both.
   - Owns only: ?screen= in the URL (never touches Shopify's filter.* params),
     .agux-hide on .sf__col-item, the rail DOM it builds itself, and the
     [data-agux-count] text (original value preserved).
   - No dependencies, no assumptions about third-party DOM.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__agxBrowse) return;
  window.__agxBrowse = 1;

  var GRID_SEL = '#CollectionProductGrid [data-ag-size]';
  var RAIL_SEL = '[data-agux-rail]';
  var COUNT_SEL = '[data-agux-count]';
  var PARAM = 'screen';

  var state = { sel: '', sig: '' };

  function $(sel, root) { return (root || document).querySelector(sel); }

  function readUrlSel() {
    try {
      return new URLSearchParams(window.location.search).get(PARAM) || '';
    } catch (e) { return ''; }
  }

  function writeUrlSel(sel) {
    try {
      var u = new URL(window.location.href);
      if (sel) { u.searchParams.set(PARAM, sel); } else { u.searchParams.delete(PARAM); }
      window.history.replaceState(window.history.state, '', u);
    } catch (e) { /* private-mode etc.: filtering still works, URL just stays */ }
  }

  function collect() {
    var items = document.querySelectorAll(GRID_SEL);
    if (!items.length) return null;
    var counts = {};
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      var s = items[i].getAttribute('data-ag-size');
      if (!s) continue;
      counts[s] = (counts[s] || 0) + 1;
      total++;
    }
    var sizes = Object.keys(counts).sort(function (a, b) { return parseFloat(b) - parseFloat(a); });
    return { items: items, counts: counts, sizes: sizes, total: total };
  }

  function apply(data) {
    var shown = 0;
    for (var i = 0; i < data.items.length; i++) {
      var el = data.items[i];
      var match = !state.sel || el.getAttribute('data-ag-size') === state.sel;
      el.classList.toggle('agux-hide', !match);
      if (match) shown++;
    }
    var status = $(COUNT_SEL) ? $(COUNT_SEL).closest('[data-agux-rail] [data-agux-status]') : $('[data-agux-status]');
    updateStatus(status, state.sel, shown, data.total);
  }

  function updateStatus(status, selected, shown, total) {
    // R5-B3 (critique #3): feedback must be visible AND announced on mobile.
    //  - compact "N / M" inline beside the rail label (visible at every width)
    //  - the toolbar count node (rendered, never display:none any more)
    //  - the rail's role=status line, which also carries the zero-match case
    var compact = $('[data-agux-rail-count]');
    if (compact) {
      compact.textContent = selected ? shown + ' / ' + total : '';
    }
    if (status) {
      if (!selected) {
        status.textContent = '';
      } else if (shown === 0) {
        status.textContent = 'No products in ' + selected + '\u2033 here. Choose another size, or tap All.';
      } else {
        status.textContent = 'Showing ' + shown + ' of ' + total + ' products for ' + selected + '\u2033';
      }
    }
    var c = $(COUNT_SEL);
    if (!c) return;
    if (selected && shown !== total) {
      c.textContent = shown === 0
        ? 'No matches for ' + selected + '\u2033'
        : 'Showing ' + shown + ' of ' + total + ' products';
    }
  }

  function buildChips(rail, data) {
    var row = $('[data-agux-rail-row]', rail);
    if (!row) return;
    row.textContent = '';
    row.appendChild(chip('All', data.total, ''));
    data.sizes.forEach(function (s) {
      row.appendChild(chip(s + '\u2033', data.counts[s], s));
    });
  }

  function chip(label, count, value) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'agux-chip';
    b.setAttribute('aria-pressed', String(state.sel === value));
    b.setAttribute('data-agux-value', value);
    var t = document.createElement('span');
    t.textContent = label;
    var n = document.createElement('span');
    n.className = 'agux-chip-count ux-num';
    n.textContent = '(' + count + ')';
    b.appendChild(t);
    b.appendChild(n);
    return b;
  }

  function init() {
    var rail = $(RAIL_SEL);
    var data = collect();
    if (!rail || !data) return;

    // Fewer than two sizes = nothing to narrow; keep the rail hidden.
    if (data.sizes.length < 2) { rail.hidden = true; return; }

    var sig = data.sizes.join('|') + ':' + data.total;
    if (rail.hidden || sig !== state.sig) {
      state.sig = sig;
      buildChips(rail, data);
      rail.hidden = false;
    }

    // Restore/keep selection; drop it if that size no longer exists.
    var wanted = state.sel || readUrlSel();
    state.sel = (wanted && data.counts[wanted]) ? wanted : '';

    apply(data);

    var row = $('[data-agux-rail-row]', rail);
    if (row && !row.__agxBound) {
      row.__agxBound = true;
      row.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-agux-value]');
        if (!btn) return;
        state.sel = btn.getAttribute('data-agux-value') === state.sel ? '' : btn.getAttribute('data-agux-value');
        var chips = row.querySelectorAll('.agux-chip');
        for (var i = 0; i < chips.length; i++) {
          chips[i].setAttribute('aria-pressed',
            String(chips[i].getAttribute('data-agux-value') === state.sel));
        }
        writeUrlSel(state.sel);
        apply(collect() || data);
      });
    }
  }

  // Re-init after facet section swaps and load-more appends. Debounced so
  // burst mutations (Kaching/Judge.me injections) cost one pass.
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; init(); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  // R5-Q3: acknowledge sort / pagination the instant the control fires.
  // Both are full-page navigations (storefront facets); without this the tap
  // looks ignored until the network answers. Opacity-only dim (see
  // ag-ux-r5-B3-COLLECTION.css §8): no layout shift, no motion. Cleared on
  // pageshow so Back/bfcache never restores a frozen-looking grid.
  function markBusy() {
    var g = document.getElementById('CollectionProductGrid');
    if (g) g.setAttribute('data-agux-busy', 'true');
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('select[name="sort_by"]')) markBusy();
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var pag = e.target.closest('#CollectionProductGrid .pagination a');
    if (pag && !pag.getAttribute('href')) return;
    if (pag) markBusy();
  }, true);
  window.addEventListener('pageshow', function () {
    var g = document.getElementById('CollectionProductGrid');
    if (g) g.removeAttribute('data-agux-busy');
  });
})();
